import { authorisedContact } from "../../config/contact";
import "./CampusFooter.css";
import { Link } from "react-router-dom";
import campusLogo from "../../Assets/EMEI logo.jpeg";
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaYoutube, FaArrowRight } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

// Replace platform homepages with official EMEI profile URLs when available.
const socialLinks = [
  { label: "Instagram", href: "https://www.instagram.com/", Icon: FaInstagram },
  { label: "Facebook", href: "https://www.facebook.com/", Icon: FaFacebookF },
  { label: "X", href: "https://x.com/", Icon: FaXTwitter },
  { label: "LinkedIn", href: "https://www.linkedin.com/", Icon: FaLinkedinIn },
  { label: "YouTube", href: "https://www.youtube.com/", Icon: FaYoutube },
];

const linkGroups = [
  {
    title: "Explore",
    links: [
      { label: "Home", to: "/" },
      { label: "About us", to: "/about" },
      { label: "Career", to: "/career" },
      { label: "Campus gallery", to: "/gallery" },
    ],
  },
  {
    title: "Student links",
    links: [
      { label: "Student login", to: "/login" },
      { label: "Create an account", to: "/register" },
      { label: "Student dashboard", to: "/student-dashboard" },
      { label: "Career opportunities", to: "/career" },
    ],
  },
];

export default function CampusFooter() {
  return (
    <footer className="campus-footer">
      <div className="campus-footer__container">
        <div className="campus-footer__main">
          <div className="campus-footer__content">
            <Link to="/" className="campus-footer__brand" aria-label="EMEI home">
              <img src={campusLogo} alt="" className="campus-footer__logo" />
              <span className="campus-footer__brand-name">EMEI</span>
            </Link>
            <p className="campus-footer__description">
              Discover learning opportunities, explore campus life, and take the next step in your journey.
            </p>
            <div className="campus-footer__social" aria-label="Social platforms">
              {socialLinks.map(({ label, href, Icon }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer"
                  aria-label={`${label} (opens in a new tab)`} title={label}>
                  <Icon aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {linkGroups.map((group) => (
            <nav key={group.title} className="campus-footer__column" aria-label={`Footer ${group.title}`}>
              <h2>{group.title}</h2>
              <ul>
                {group.links.map((link) => (
                  <li key={link.label}><Link to={link.to}>{link.label}</Link></li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="campus-footer__column">
            <h2>Connect with us</h2>
            <p>Authorised contact: <a href={authorisedContact.telephone}>{authorisedContact.phone}</a></p>
            <p>Find our location and ways to connect with the EMEI community.</p>
            <Link to="/lastpage" className="campus-footer__contact-link">
              Contact &amp; location <FaArrowRight aria-hidden="true" />
            </Link>
            <Link to="/register" className="campus-footer__cta">
              Join EMEI <FaArrowRight aria-hidden="true" />
            </Link>
          </div>
        </div>

        <div className="campus-footer__bottom">
          <span>&copy; {new Date().getFullYear()} EMEI. All rights reserved.</span>
          <div className="campus-footer__bottom-links">
            <Link to="/about">About EMEI</Link>
            <Link to="/lastpage">Get in touch</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
